import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { HiChevronRight, HiOutlineHome, HiOutlineOfficeBuilding } from 'react-icons/hi';
import SofaImg from '../../Images/Redesign/sofa.png';
import HomeImg from '../../Images/Redesign/home.png';
import KitchenImg from '../../Images/Redesign/kitchen.png';
import WomenCleaningimg from '../../Images/Redesign/about2.png';
import WomenCleaningimg1 from '../../Images/Redesign/about1.png';
import HowItWorks from '../../Components/HowitsWork/Howitswork';
import Homecleaning from '../../Images/HomeImages/house-cleaning.png';
import CommercialCleaning from '../../Images/HomeImages/office-cleaning.png';
import BathroomImg from '../../Images/Redesign/bathroom.png';
import PricingComponent from '../../Components/PricingCard/Pricingcard';
import CallBack from '../../Components/CallBack/CallBack';
import MainHomeContainer from '../../Components/MainHomeContainer/MainHomeContainer';
import Footer from '../../Components/Footer/Footer';
import NewHomeNav from '../../Components/Navbar/NewNavbar';

const useCounter = (end, duration = 2000) => {
    const [count, setCount] = useState(0);
    const countRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.5 }
        );

        if (countRef.current) {
            observer.observe(countRef.current);
        }

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (!isVisible) return;

        let start = 0;
        const increment = end / (duration / 16);
        const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
                setCount(end);
                clearInterval(timer);
            } else {
                setCount(Math.floor(start));
            }
        }, 16);

        return () => clearInterval(timer);
    }, [end, duration, isVisible]);

    return [count, countRef];
};

function MainHome() {
    const [yearsCount, yearsRef] = useCounter(5, 2500);
    const [clientsCount, clientsRef] = useCounter(10, 2500);

    const services = [
        {
            title: "Full Home Cleaning",
            description: "Expert, eco-friendly deep cleaning for every corner of your domestic sanctuary.",
            image: HomeImg,
            link: "/home-cleaning",
            tag: "Bestseller"
        },
        {
            title: "Sofa Cleaning",
            description: "Professional restoration that removes deep-seated dust and stubborn stains.",
            image: SofaImg,
            link: "/sofa-cleaning",
            tag: "Popular"
        },
        {
            title: "Bathroom Cleaning",
            description: "Intensive sanitization for sparkling surfaces and a hygienic environment.",
            image: BathroomImg,
            link: "/bathroom-cleaning",
            tag: "Essential"
        },
        {
            title: "Kitchen Cleaning",
            description: "Deep degreasing and sanitizing for the heart of your modern home.",
            image: KitchenImg,
            link: "/Kitchen-cleaning",
            tag: "Premium"
        }
    ];

    return (
        <div className="bg-white">
            <NewHomeNav />
            <MainHomeContainer />

            {/* Services Section */}
            <section className="section-padding bg-secondary/30" id="MainHome-services-container">
                <div className="container-custom">
                    <div className="text-center max-w-3xl mx-auto mb-20 space-y-4 fade-up">
                        <p className="text-primary font-bold uppercase tracking-widest text-sm">Our Signature Services</p>
                        <h2 className="text-4xl md:text-5xl font-heading font-black">Most Popular Cleaning Solutions</h2>
                        <p className="text-muted-foreground text-lg">Experience unmatched quality with our specialized cleaning services tailored for modern homes.</p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {services.map((service, index) => (
                            <div key={index} className="card-premium group">
                                <div className="relative h-64 overflow-hidden">
                                    <img 
                                        src={service.image} 
                                        alt={service.title} 
                                        className="w-full h-full object-cover" 
                                    />
                                    <div className="absolute top-4 left-4">
                                        <span className="bg-white/90 backdrop-blur-md text-primary text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-full shadow-sm">
                                            {service.tag}
                                        </span>
                                    </div>
                                </div>
                                <div className="p-8 space-y-4">
                                    <h3 className="text-xl font-bold group-hover:text-primary transition-colors">{service.title}</h3>
                                    <p className="text-muted-foreground text-sm line-clamp-2 leading-relaxed">
                                        {service.description}
                                    </p>
                                    <Link 
                                        to={service.link} 
                                        className="inline-flex items-center text-primary font-bold text-sm tracking-tight hover:gap-2 transition-all"
                                    >
                                        Explore Details <HiChevronRight className="text-lg" />
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* About Section */}
            <section className="section-padding overflow-hidden">
                <div className="container-custom">
                    <div className="grid lg:grid-cols-2 gap-20 items-center">
                        <div className="relative">
                            <div className="grid grid-cols-2 gap-8">
                                <div className="flex flex-col">
                                    <div className="rounded-3xl overflow-hidden">
                                        <img src={WomenCleaningimg1} alt="Cleaning" className="w-full h-[28rem] object-cover" />
                                    </div>
                                    <div className="bg-accent p-8 rounded-3xl text-accent-foreground text-center space-y-2 mt-auto">
                                        <p className="text-4xl font-black" ref={yearsRef}>{yearsCount}+</p>
                                        <p className="text-xs uppercase font-bold tracking-widest opacity-80">Years of Experience</p>
                                    </div>
                                </div>
                                <div className="flex flex-col space-y-6">
                                    <div className="bg-primary p-8 rounded-3xl text-white text-center space-y-2">
                                        <p className="text-4xl font-black" ref={clientsRef}>{clientsCount}k+</p>
                                        <p className="text-xs uppercase font-bold tracking-widest opacity-80">Happy Clients</p>
                                    </div>
                                    <div className="rounded-3xl overflow-hidden">
                                        <img src={WomenCleaningimg} alt="AstraClean" className="w-full h-[28rem] object-cover" />
                                    </div>
                                </div>
                            </div>
                            {/* Decorative background circle */}
                            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-primary/5 rounded-full -z-10 blur-3xl scale-125"></div>
                        </div>

                        <div className="space-y-8">
                            <div className="space-y-4">
                                <p className="text-primary font-bold uppercase tracking-widest text-sm">About AstraClean</p>
                                <h2 className="text-4xl md:text-5xl font-heading font-black leading-tight">Reliable, Affordable & Eco-Friendly Experts</h2>
                                <p className="text-muted-foreground text-lg leading-relaxed">
                                    Our company provides top-quality, affordable services with a strong commitment to eco-friendly practices. We deliver reliable solutions that ensure efficiency, cost-effectiveness, and minimal environmental impact.
                                </p>
                            </div>

                            <div className="grid sm:grid-cols-2 gap-6">
                                <div className="flex gap-4 p-6 rounded-2xl bg-secondary/50 border border-primary/5 hover:border-primary/20 transition-all group">
                                    <div className="w-12 h-12 shrink-0 rounded-xl bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-all">
                                        <HiOutlineHome size={24} />
                                    </div>
                                    <div className="space-y-1">
                                        <h4 className="font-bold">Home Cleaning</h4>
                                        <p className="text-xs text-muted-foreground leading-relaxed">Comprehensive cleaning making every space spotless.</p>
                                    </div>
                                </div>
                                <div className="flex gap-4 p-6 rounded-2xl bg-secondary/50 border border-primary/5 hover:border-primary/20 transition-all group">
                                    <div className="w-12 h-12 shrink-0 rounded-xl bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-all">
                                        <HiOutlineOfficeBuilding size={24} />
                                    </div>
                                    <div className="space-y-1">
                                        <h4 className="font-bold">Commercial</h4>
                                        <p className="text-xs text-muted-foreground leading-relaxed">Expert cleaning for productive workplaces.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="pt-4">
                                <Link to="/about" className="btn-primary">
                                    More About Us
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <HowItWorks />
            
            {/* CallBack Section Wrapper */}
            <div className="bg-primary">
                <CallBack />
            </div>

            {/* Pricing Section Wrapper */}
            <section className="section-padding bg-secondary/30">
                <div className="container-custom">
                    <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
                        <p className="text-primary font-bold uppercase tracking-widest text-sm">Transparent Pricing</p>
                        <h2 className="text-4xl md:text-5xl font-heading font-black">Choose Your Perfect Plan</h2>
                    </div>
                    <PricingComponent />
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default MainHome;

